
import { defineComponent, reactive, toRefs ,getCurrentInstance,onMounted} from 'vue'
import {useRouter, useRoute, RouteLocationMatched, onBeforeRouteUpdate} from 'vue-router';
import {useStore} from 'vuex'
import searchBtn  from '../common/searchEl.vue'
import pageSearch from '../common/pageHead.vue'
import Footer1 from '@/components/common/footer.vue'
import Footer2 from '@/components/footer/footer.vue'
import {ArrowRight} from '@element-plus/icons-vue'
export default defineComponent({
    components:{searchBtn,pageSearch,Footer1,Footer2,ArrowRight},
    setup() {
        const {proxy,appContext}= getCurrentInstance() as any
        const axios =appContext.config.globalProperties.axios
        const route=useRoute()
        const router=useRouter()
        const store=useStore()
        const state:any=reactive({
            titleList:[],//大标题
            typeList:[],//分类
            videoList:[],//视频
            platformJson:appContext.config.globalProperties.platformJson,
            titlePer:6,//大标题每行占比-每行几个大标题(24/titlePer)
            typePer:12,//分组每行占比-每行展示几个分组(24/typePer)
            artPer:12,//小文章每行占比-每行几个小文章（24/artPer）
        })
        const methods=reactive({
            // // 前往文章页面
            // toArticle:(data:any)=>{
            //     // console.log(window.location.origin+'/article/'+data.docUrl.slice(2),'666')
            //     window.open(window.location.origin+'/article/'+data.docUrl.slice(2),'_blank')
            // },
            // 打开文章链接
            openArt:(url:any)=>{
                if(url){
                    window.open(url,'_blank')
                }
            },
            // 获取页面数据
            getList:()=>{
                axios.get('/open/home',{
                }).then((res:any)=>{
                    if(res.data.code==200){
                        let list:any=JSON.parse(res.data.data)
                        let routeType= window.location.href.includes('#')//是否是hash模式
                        let routePath=routeType?'#/article/':'article/'
                        let titleList:any=[]
                        let typeList:any=[]
                        let videoList:any=[]
                        list.map((item:any)=>{
                            if(item.jumpUrl){
                                // item.jumpUrl=window.location.origin+'/article/'+item.jumpUrl?.slice(2)
                                item.jumpUrl=window.location.origin+window.location.pathname+routePath+item.jumpUrl?.slice(2)
                            }
                            if(item.list){
                                item.list.map((one:any)=>{
                                    // one.jumpUrl=window.location.origin+'/article/'+one.jumpUrl?.slice(2)
                                    one.jumpUrl=window.location.origin+window.location.pathname+routePath+one.jumpUrl?.slice(2)
                                })
                            }
                            if(item.groupType==1){
                                typeList.push(item)
                            }else if(item.groupType==2){
                                titleList.push(item)
                            }else if(item.groupType==3){
                                videoList.push(item)
                            }
                        })
                        state.typeList=typeList
                        state.titleList=titleList
                        state.videoList=videoList
                        // console.log(state.helpData,state.problemData,'problemData')
                    }
                })
            },
            // 页面适配
            handleRowCardCount:()=>{
                let pageWidth:any=window.innerWidth
                if(pageWidth <=1000){
                    state.titlePer=12
                    state.typePer=24
                    state.artPer=12
                }else if(pageWidth <=1300){
                    state.titlePer=12
                    state.typePer=12
                    state.artPer=24
                }else if(pageWidth <=1500){
                    state.titlePer=12
                    state.typePer=12
                    state.artPer=24
                }else if(pageWidth <=1600){
                    state.titlePer=6
                    state.typePer=12
                    state.artPer=24
                }else if(pageWidth <=1800){
                     state.titlePer=6
                    state.typePer=12
                    state.artPer=12
                }else {
                    state.titlePer=6,
                    state.typePer=12
                    state.artPer=12
                }
                // if()
            },
            onVideoLoaded:(item:any)=>{
                item.videoLoaded=true
            }
        })
        onMounted(()=>{
            document.title=`${state.platformJson.name} - 帮助中心`
            methods.getList()
            methods.handleRowCardCount()
            window.addEventListener('resize',()=>{
                methods.handleRowCardCount()
            })
        })
        return {
            ...toRefs(state),
            ...toRefs(methods)
        }
    },
})
